import { render, staticRenderFns } from "./ToggleButtonParts.vue?vue&type=template&id=2514072b&scoped=true"
import script from "./ToggleButtonParts.vue?vue&type=script&lang=ts"
export * from "./ToggleButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./ToggleButtonParts.vue?vue&type=style&index=0&id=2514072b&prod&lang=scss&scoped=true"
import style1 from "./ToggleButtonParts.vue?vue&type=style&index=1&id=2514072b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514072b",
  null
  
)

export default component.exports